import { NotificationAvatar } from "shared/ui/notifications/notification-generic/base-parts/avatar";

export const NotificationCampaignImage = () => (
  <NotificationAvatar placeholderText="C" isLazy />
);
